export enum AXIOS_METHODS {
    GET = 'GET',
    POST = 'POST',
    PATCH = 'PATCH',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

export enum OPT_IN_OPTIONS {
    OPT_IN = 'optIn',
    OPT_OUT = 'optOut',
}

export enum MULTI_LOCATION_SELECT_VARIANTS {
    SIGN_IN = 'SIGN_IN',
    SIGN_UP = ' SIGN_UP',
}

export enum MIDDLELAYER_RESPONSE_CODE {
    USER_DOES_NOT_EXIST = 'HF-1001',
    USER_NOT_FOUND = 'HF-1003',
    INVALID_BEAUTY_HEALTH_ID = 'HF-1023',
    USER_ALREADY_EXIST = 'HF-1088',
    SIGNUP_KEY_EXPIRED = 'HF-1101',
    HYDRAFACIALIST_SIGNUP_KEY_EXPIRED = 'HF_1155',
    LOYALTY_ACCESS_TOKEN_EXPIRED = 'HF-1110',
    USER_NOT_A_CONSUMER = 'HF-1112',
    INVALID_VERIFICATION_CODE = 'HF_1065',
    INVALID_SESSION = 'HF_1084',
    USER_WITH_MOBILE_NUMBER_EXIST = 'HF_1120',
    USER_WITH_EMAIL_EXIST = 'HF_1119',
    SOMETHING_WENT_WRONG = 'HF-1040',
    SUB_ACCOUNTS_FOUND = 'HF_1122',
    USER_NOT_REGISTERED = 'HF-1012',
}

export enum ROUTES {
    DOWNLOAD_APP = '/download-app',
    HOW_IT_WORKS = '/how-it-works',
    SKIN_CONDITIONS = '/skin-conditions/',
    TREATMENT_TYPES = '/treatment-types/',
    FIND_HYDRAFACIALIST = '/find-a-hydrafacialist/',
    ABOUT_US = '/about/',
    NEWSROOM = 'https://investors.beautyhealth.com/news-events/news-releases/',
    INVESTOR_RELATIONS = 'https://investors.beautyhealth.com/',
    CAREERS = '/careers/',
    CLAIMS = '/claims/',
    DEVICES = '/device/',
    TREATMENTS = '/treatments/',
    REWARDS = '/rewards/',
    TRAINING = '/training/',
    COMMUNITY = '/community/',
    STORE = '/store/',
    TALK_WITH_SALES = '/talk-with-sales/',
    PRIVACY = '/privacy-policy/',
    REQUEST_FORM = '/request-form/',
    DATA_SHARING_AGREEMENT = '/data-sharing-agreement/',
    TERMS_OF_SERVICE = '/terms-of-service/',
    TERMS_OF_USE = '/terms-of-use/',
    TERMS_AND_CONDITIONS = '/terms-conditions/',
    FOR_PROFESSIONAL = '/professional/',
    ACCOUNTS = '/accounts',
    TREATMENT_TYPE_DETAIL = '/treatment-type-detail',
    HOME = '/',
    BOOSTERS = '/booster/',
    FRESH_ACCESS = '/fresh-access/',
    SEARCH = '/search/',
    SHOP_MERCHANDISE = 'https://shop.hydrafacial.com/',
    HKX = '/HKX/',
    HFX = '/hfx-franchise/',
    PATENTS = '/patents/',
    IFU = '/ifu/',
    JLOPROVIDERHOME = '/professional/j-lo-beauty-booster/',
    JLO_CLIENT_HOME = '/j-lo-beauty-booster/',
    TERMS = '/giveaway-terms/',
    SHOP_EGIFT_CARDS = 'https://hydrafacialnation.com/?utm_source=hydrafacial',
    SUPPLIER = '/supplier/',
    EVENTS = '/events/',
    KERAVIVE = '/keravive-old/',
    POST_DETAILS = '/post-details/',
    CONSUMER_BOOSTER = '/consumer-booster/',
    HFXCLUSIVE = '/hfx-business/',
    GLOWTOGETHER = '/professional/become-a-brand-ambassador/',
    EXPLORE_HYDRAFACIAL = '/explore-hydrafacial/',
    EMAIL_SUBMISSION = '/submissions/',
    CUSTOMER_PROVIDER = '/professional-resources/',
    PROFESSIONAL_TESTIMONIALS = '/professional-testimonials/',
    PROFESSIONAL_TESTIMONIALS_SUCCESS = '/professional-testimonials/success',
    KERAVIVE_B2C = '/keravive/',
    KERAVIVE_B2B = '/professional/keravive/',
    SCHOOL = '/schools/',
    LOYALTY_LANDING = '/mybeautyhealth-loyalty-rewards/',
    DASHBOARD_PAGE = '/dashboard/',
    HYDRALOCK_HA_BOOSTER = '/hydralock-ha-booster',
    HYDRAFACIAL_IN_THE_NEWS = '/hydrafacial-in-the-news',
    // syndeo
    SIGNIN = '/accounts/signin',
    SIGNUP = '/accounts/signup',
    SELECTACCOUNT = '/accounts/select-account',
    SIGNUPSTEPS = '/signup/:step',
    DASHBOARD = '/dashboard',
    CLIENT_REWARDS = '/dashboard/client-rewards',
    ACCOUNT_SETTINGS = '/dashboard/account',
    ACCOUNT_DELETE = '/dashboard/account/delete',
    SYNDEO_REPORTS = '/dashboard/syndeo-reports',
    SYNDEO_BOOSTER = '/dashboard/syndeo-reports/:boosterType',
    THE_DROP = 'https://thedrop.hydrafacial.com/',
    TREATMENT = '/dashboard/treatment',
    REWARDS_PAGE = '/dashboard/rewards',
    TREATMENT_HISTORY = '/dashboard/treatment/:treatmentId',
    STORE_TAB = 'https://www.hydrafacial.store/',
    HYDRAFACIALISTS = '/dashboard/hydrafacialists',
    PROVIDER = '/dashboard/provider',
    CONSENT = '/consent',
    ACCOUNTS_SIGNIN = '/signin',
    ACCOUNTS_SIGNUP = '/signup',
    ACCOUNTS_SELECT_ACCOUNT = '/select-account',
}

/**
 * Content stack
 */
export enum CONTENT_BODY {
    LISTINGS = 'BodyBodyListings',
    LISTING = 'BodyBodyListing',
    CALL_OUT = 'BodyBodyCallout',
    IMAGE_TEXT = 'BodyBodyImageText',
    TEXT = 'BodyBodyText',
    PRESS_HIGHLIGHTS = 'BodyBodyPressHighlights',
    SPONSORS = 'BodyBodySponsors',
    VIDEO_LINKS = 'BodyBodyCarouselVideoLinks',
    CODE_BLOCK = 'BodyBodyCodeBlock',
    SPLIT_IMAGE_BLOCK = 'BodyBodySplitImageBlock',
    POINTERS_BLOCK = 'BodyBodyPointersBlock',
    IMAGE_GRID = 'BodyBodyImageGrid',
    CONTENT_GRID = 'BodyBodyContentGrid',
    SLIDE_BLOCK = 'BodyBodyCarousel',
    TREATMENT_RESULTS = 'BodyBodyTreatmentResults',
    SPLIT_TEXT_BLOCK = 'BodyBodySplitTextBlock',
    QUOTE = 'BodyBodyQuote',
}

export enum POST_CONTENT_BODY {
    IMAGE = 'PostContentImage',
    TEXT = 'PostContentText',
    CODE = 'PostContentCodeBlock',
    LISTINGS = 'PostContentListings',
}

export enum POINTER_CONTENT_BODY {
    POINTER_SPLIT_IMAGE_BLOCK = 'Split image block',
    POINTER_TWO_COLUMN_LIST = 'Two column list',
    POINTER_FEATURED_BULLETS = 'Featured bullets',
    SPLIT_IMAGE_TWO_COLUMN = 'Split image two column block',
    MILESTONES = 'Milestones',
    SPLIT_MILESONES = 'Split milestone',
    SPLIT_ENHANCED_MILESTONE = 'Split enhanced milestone',
    SPLIT_ENHANCED_POINTER = 'Split enhanced pointer',
    HORIZONTAL_MILESTONE = 'Horizontal Milestones',
    HORIZONTAL_MILESTONE_SMALL = 'Horizontal Milestones Small',
    SPLIT_ENHANCED_POINTER_HEAD_WITH_TITLE = 'Split enhanced pointer with head title',
    BANNER_POINTER_BLOCK = 'Banner pointer block',
    BANNER_SLIDER_BLOCK = 'Banner Slider Block',
}

export enum LISTING_TYPE {
    TESTIMONIAL = 'Testimonial',
    TREATMENT = 'Treatment',
    TEAM = 'Team',
    TREATMENT_WITH_BANNER = 'Treatment with banner',
    PRODUCT_CATEGORY = 'Product Category',
}

export enum LAYOUT_LIST {
    TREATMENT_GRID = 'Treatment grid',
}

export enum CODE_TYPE {
    YOUTUBE = 'Youtube',
    VIMEO = 'Vimeo',
}

export enum TEXT_TYPE {
    ACCORDIAN = 'Accordion',
    CHECK_LIST = 'Checklist',
    TEXT = 'Text',
}

export enum SLIDER_TYPE {
    POINTER_SPLIT_IMAGE = 'Pointer - Split image',
    BANNER_SLIDER = 'Banner - Slider',
    ARTICLE_SLIDER = 'Article - Slider',
    MULTI_SLIDER = 'Multi - Slider',
    PARTIAL_VISIBLE = 'Partial Visible - Slider',
}

export enum IMAGE_GRID_TYPE {
    GALLERY = 'Gallery',
    BRANDS = 'Brands',
}

export enum SOCIAL_MEDIA_URL {
    FACEBOOK = 'https://www.facebook.com/hydrafacial/',
    INSTAGRAM = 'https://instagram.com/hydrafacial/',
}

export enum FORM_TYPE {
    SALES = 'sales',
    TRAINING = 'training',
    REWARDS = 'rewards',
}

export enum BOOSTER_TYPE {
    SOLUTIONS = 'solutions',
    BRANDS = 'brands',
    ENHANCEMENTS = 'enhancements',
    CARE = 'care',
}

export enum PROVIDER_BOOSTER_TYPE {
    SOLUTIONS = 'provider-solutions',
    BRANDS = 'provider-brands',
    ENHANCEMENTS = 'provider-enhancements',
    CARE = 'provider-care',
}

export enum SPLIT_BLOCK_TYPE {
    HFXOFFERING = 'HFX Offering',
    HFXTRAOFFERING = 'HFXTRA Offering',
    HFXCLUSIVEOFFERING = 'Black Panel',
    REQUEST_PROVIDER_FORM_EMBED = 'Request Provider Form Embed',
}

export enum SIGNUP_FORM_TYPE {
    USER = 'user-details',
    OTPVERIFY = 'otp-verify',
}

export enum PARENT_ROUTES {
    ONBOARDING = 'Onboarding',
    DASHBOARD = 'Dashboard',
    SIGNIN = 'Signin',
}

export enum NAVIGATION_TYPE {
    HEADER = 'Header Navigation',
    CAREER = 'Career Navigation',
    CUSTOMER = 'Customer Navigation',
    PROVIDER = 'Provider Navigation',
    TRETMENT_TYPE = 'Treatment Type Navigation',
    FOOTER = 'Footer Navigation',
    MOBILE_MENU = 'Mobile Navigation',
}

export enum CLICK_ID {
    SEARCH_FULLSITE = 'search_fullsite',
    FACEBOOK_FOOTER = 'facebook_footer',
    INSTAGRAM_FOOTER = 'instagram_footer',
    HAMBURGERMENU_CLICK = 'hamburgermenu_click',
    FACEBOOK_POST = 'facebook_post',
    SUBMIT_BUTTON_1_HFXFRANCHISE = 'submitbtn_hfxfranchise',
    SUBMIT_BUTTON_2_HFXFRANCHISE = 'submitbtn2_hfxfranchise',
    NEWSLETTER_SIGNUP = 'newsletter_signup',
}
